"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlUIScreenStatusValidation = void 0;
const ChargerUIScreenStatusValidation_1 = require("./ChargerUIScreenStatusValidation");
const InstructionalStepValidation_1 = require("./InstructionalStepValidation");
class ChargerControlUIScreenStatusValidation {
    static isValid(entity) {
        // Validate entity.ports for existence and correct type.
        if (entity.ports == undefined)
            return false;
        if (!Array.isArray(entity.ports))
            return false;
        if (!entity.ports.every((elem) => {
            if (!ChargerUIScreenStatusValidation_1.ChargerUIScreenStatusValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        // If entity.unassigned_instructional_step exists, validate that it has the correct type.
        if (entity.unassigned_instructional_step != undefined) {
            if (!InstructionalStepValidation_1.InstructionalStepValidation.isValid(entity.unassigned_instructional_step))
                return false;
        }
        // If entity.unassigned_possible_steps exists, validate that it has the correct type.
        if (entity.unassigned_possible_steps != undefined) {
            if (!Array.isArray(entity.unassigned_possible_steps))
                return false;
            if (!entity.unassigned_possible_steps.every((elem) => {
                if (!InstructionalStepValidation_1.InstructionalStepValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        return true;
    }
}
exports.ChargerControlUIScreenStatusValidation = ChargerControlUIScreenStatusValidation;
